export const isUserPro = (member_type: string): boolean =>
    member_type === 'pro' || member_type === 'editor' || member_type === 'owner'
